class SftpConnectController extends AbstractIntegrationController
	@register()

	integrationId: 'sftp'
